/**
 * Bookie prices. Players bet at a bookmaker-style price, not on the exchange: one price
 * per selection, back only, no commission. It is the exchange's best back with a slight
 * margin taken off, so it always sits just under what the exchange offers.
 *
 * Shared by the server, which prices and checks every bet, and the screens, which show
 * the same number — so the price clicked is the price checked.
 */

/** The bookmaker's margin: 1%. A best back of 2.00 is offered at 1.98. */
export const BOOKIE_MARGIN = 0.01

/**
 * The price offered for a selection whose best back on the exchange is `bestBack`, or
 * null when there is none to offer. Rounded down to the penny, so the margin is never
 * rounded away; anything that would come out at evens-money-or-worse (1.00) is not offered.
 */
export function bookiePrice(bestBack: number | null | undefined): number | null {
  if (!bestBack || !Number.isFinite(bestBack) || bestBack <= 1) return null
  const p = Math.floor((bestBack / (1 + BOOKIE_MARGIN)) * 100 + 1e-9) / 100
  return p > 1 ? p : null
}

/** An accumulator's price: its legs' prices multiplied, to the penny. */
export function accumulatorPrice(prices: number[]): number {
  return Math.round(prices.reduce((t, p) => t * p, 1) * 100) / 100
}
